import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';

const styles = theme => ({
  closeIcon: {
    position: 'absolute',
    right: 20,
    top: 20,
  },
  content: {
    padding: isMobileApp
      ? '50px 20px 10%'
      : '20px 80px',
    margin: '10px auto',
    width: '100%',
    textAlign: 'left',
    color: '#222',
    boxSizing: 'border-box',
  },
});

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

class EntryNoteContentDialog extends React.Component {
  render() {
    const {
      classes,
      isDialogOpen,
      onDialogClose,
      note,
    } = this.props;

    return (
      <Dialog
        fullScreen={isMobileApp}
        scroll="paper"
        open={isDialogOpen}
        fullWidth
        maxWidth="md"
        onClose={onDialogClose}
        TransitionComponent={Transition}
        disableBackdropClick={true}
        className="timetable-entry-note-content-dialog"
      >
        <IconButton
          aria-label="Close"
          onClick={onDialogClose}
          className={`timetable-entry-note-content-close-button ${classes.closeIcon}`}
        >
          <CloseIcon/>
        </IconButton>
        <div className={classes.content}>
          <div dangerouslySetInnerHTML={{
              __html: note,
            }}></div>
        </div>
      </Dialog>
    );
  }
}

export default withStyles(styles)(withTranslation()(EntryNoteContentDialog));

